import bg2 from '../imgs/Steadywhenwalking.jpg';
import bg3 from '../imgs/dia-diem-du-lich-he-7.jpeg';
import mind from '../imgs/mind&body.png';
import Personal from '../imgs/Personal.png';
import sleep from '../imgs/sleep.png';
import spr from '../imgs/spr.png';
import per from '../imgs/per.png';
import rel from '../imgs/rel.png';
import env from '../imgs/env.png';
import nutri from '../imgs/nutri.png';
import move from '../imgs/move.png';
import cus from '../imgs/cus.png';
import codung from '../imgs/codung.png';
import maichau from '../imgs/maichau.png';
import cohy from '../imgs/cohy.png';

export default function MB_OUTPRODUCT() {
  return (
    <section className="relative text-white py-20 overflow-hidden z-20 block md:hidden">
      {/* Background */}
      <div className="absolute inset-0 z-[-2]">
        <img src={bg2} alt="background" className="w-full h-full object-cover" />
      </div>

      {/* Gradients */}
      <div className="absolute inset-0 z-[-1] bg-gradient-to-b from-[#0B1D26] via-[#0B1D26]/70 to-[#0B1D26]/0" />
      <div className="absolute inset-0 z-[-1] bg-gradient-to-t from-[#0B1D26] via-[#0B1D26]/10 to-transparent" />

      {/* Title */}
      <div className="relative h-[40px] flex items-center mb-4 w-full mt-[0px] md:mt-[20px] ml-4 md:ml-[50px]">
        {/* Chữ mờ lớn phía sau */}
        <h2 className="absolute text-[43px] md:text-[90px] font-bold text-white/5 uppercase leading-none z-0 select-none left-0">
          OUR PRODUCTS
        </h2>

        {/* Chữ nhỏ phía trước */}
        <div className="relative z-10 flex items-center space-x-3">
          <div className="w-[30px] h-0.5 bg-yellow-400"></div>
          <h3 className="text-yellow-400 uppercase tracking-widest text-[14px] md:text-[22px] font-semibold">
            OUR PRODUCTS
          </h3>
        </div>
      </div>

      {/* Icon Grid */}
      <div className="relative w-[280px] h-[280px] mx-auto my-10">
        {/* Central Icon */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <img src={cus} alt="customer" className="w-[92px] h-[92px]" />
        </div>

        {/* Icons Around */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2">
          <img src={mind} alt="mind" className="w-[49px] h-[52px]" />
        </div>
        <div className="absolute top-[12%] left-[85%] -translate-x-1/2">
          <img
            src={Personal}
            alt="personal"
            className="max-w-none"
            style={{ width: '85px', height: '52px' }}
          />
        </div>
        <div className="absolute top-[45%] left-[100%] -translate-y-1/2 -translate-x-full">
          <img src={sleep} alt="sleep" className="max-w-none"
            style={{ width: '43px', height: '43px' }}  />
        </div>
        <div className="absolute bottom-[20%] left-[85%] -translate-x-1/2">
          <img src={spr} alt="spr" className="w-[41px] h-[47px]" />
        </div>
        <div className="absolute bottom-0 left-2/3 -translate-x-1/2">
          <img src={per} alt="performance" className="w-[70px] h-[50px]" />
        </div>
        <div className="absolute bottom-[1%] right-1/2 -translate-x-1/2">
          <img src={rel} alt="relax" className="w-[50px] h-[50px]" />
        </div>
        <div className="absolute bottom-[12%] right-[85%] -translate-y-1/2">
          <img src={env} alt="environment" className="w-[47px] h-[47px]" />
        </div>
        <div className="absolute top-[35%] right-[85%] -translate-x-1/2">
          <img src={nutri} alt="nutrition" className="max-w-none"
            style={{ width: '34px', height: '52px' }}  />
        </div>
        <div className="absolute top-[12%] right-[72%] -translate-x-1/2">
          <img src={move} alt="nutrition" className="max-w-none"
            style={{ width: '40px', height: '44px' }}  />
        </div>
      </div>

      {/* Content */}
      <div className="w-full lg:w-1/2 text-white">
  <div className="text-justify leading-relaxed text-white px-4 mt-6 text-center text-sm">
    <h2 className="text-3xl font-miller mb-4 leading-snug">
      Clever <br />
      <span className="font-miller">Hospitality Management</span>
    </h2>
    <p className="mb-4 indent-2">
    focuses on designing sanctuaries that reflect and celebrate the natural and cultural environment. We encourage investors to opt for building design with non-toxic construction materials, native plants and creative touches from local artists.
    </p>
    <p className="mb-4 indent-2">
    We believe a vacation is not only about relaxing at the pools, but also a mind and body experience. People are always looking for both mental and physical healings. Once they have connected to nature and to their inner self, that is what we call an ultimate journey.
    </p>
    <p>The journey that we design...</p>
  </div>
</div>
      
    </section>
  );
}
